import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "timeToWords",
})
export class TimeToWordsPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return "NA";
    }

    const now = new Date();
    const inputDate = new Date(value);

    // Check if date is valid
    if (isNaN(inputDate.getTime())) {
      return "NA";
    }

    // Calculate difference in calendar days (normalize both dates to local midnight)
    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const inputMidnight = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    const diffTime = todayMidnight.getTime() - inputMidnight.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // If less than 10 days, show in words
    if (diffDays < 10) {
      if (diffDays === 0) {
        return "Hoy";
      } else if (diffDays === 1) {
        return "Ayer";
      } else {
        return `Hace ${diffDays} días`;
      }
    }

    // If 10 days or more, format as dd/mmm/yyyy
    const month_abbreviations = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

    const day = String(inputDate.getDate()).padStart(2, "0");
    const month = month_abbreviations[inputDate.getMonth()];
    const year = inputDate.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
